// extracted by mini-css-extract-plugin
export var labelWrapper = "_co-0";